(function () {
  const FORM_SELECTOR = '[data-formspark-form]';
  const submitStates = new WeakMap();

  function setState(form, state) {
    const submits = form.querySelectorAll('[type="submit"]');
    const success = form.querySelector('[data-formspark-success]');
    const error = form.querySelector('[data-formspark-error]');
    const isSubmitting = state === 'submitting';

    form.dataset.formsparkState = state;
    form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    submits.forEach(function (submit) {
      if (isSubmitting) {
        if (!submitStates.has(submit)) {
          submitStates.set(submit, {
            disabled: submit.disabled,
            ariaDisabled: submit.getAttribute('aria-disabled'),
            innerHTML: submit.innerHTML,
          });
        }
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.innerHTML = '<span>Submitting...</span>';
      } else if (submitStates.has(submit)) {
        const original = submitStates.get(submit);
        submit.disabled = original.disabled;
        if (original.ariaDisabled === null) submit.removeAttribute('aria-disabled');
        else submit.setAttribute('aria-disabled', original.ariaDisabled);
        submit.innerHTML = original.innerHTML;
        submitStates.delete(submit);
      }
    });
    if (success) success.hidden = state !== 'success';
    if (error) error.hidden = state !== 'error';
  }

  async function submit(form) {
    setState(form, 'submitting');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(Object.fromEntries(new FormData(form).entries())),
      });

      if (!response.ok) throw new Error('Formspark submission failed');

      form.reset();
      setState(form, 'success');
      const eventName = form.dataset.formsparkSuccessEvent;
      const redirect = form.dataset.formsparkRedirect;
      const analytics = window.Shopify && window.Shopify.analytics;
      if (eventName && analytics && typeof analytics.publish === 'function') {
        try {
          const publication = analytics.publish(eventName, {});
          if (publication && typeof publication.catch === 'function') publication.catch(function () {});
        } catch (ignored) {}
      }
      if (redirect) {
        window.setTimeout(function () {
          window.location.assign(redirect);
        }, 1000);
      } else {
        window.setTimeout(function () {
          setState(form, 'idle');
        }, 5000);
      }
    } catch (error) {
      setState(form, 'error');
    }
  }

  function initForm(form) {
    if (form.dataset.formsparkInitialized === 'true') return;
    form.dataset.formsparkInitialized = 'true';

    form.addEventListener('submit', function (event) {
      if (event.defaultPrevented) return;
      event.preventDefault();
      if (form.dataset.formsparkState === 'submitting') return;
      if (!form.reportValidity()) return;
      submit(form);
    });
  }

  function init(root) {
    (root || document).querySelectorAll(FORM_SELECTOR).forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, {once: true});
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.KarstFormspark = {init, submit};
})();
